import React from 'react';
// import loginImg from '../images/car_login.jpg'
import {Link} from 'react-router-dom'
import {useState} from 'react'

const Login = ( {signUserIn = f => f}) => {

    const [email, setEmail] = useState(""); 
    const [password, setPassword] = useState(""); 

    const onSubmit = (event) =>{
        event.preventDefault();
        signUserIn(email, password);
        setPassword("");
        setEmail("");
    }

    return ( 
        <div className='grid grid-cols-1 sm:grid-cols-2 h-screen w-full'>
            <div className='hident sm:block'>
                {/* < img className='w-full h-full object-cover' src={loginImg} alt=''/> */}
            </div>

            <div className= 'bg-gray-100 flex flex-col justify-center'>
                <form 
                onSubmit={onSubmit}
                className='max-w-[400px] w-full mx-auto bg-white p-4'>
                <h2 className='text-4xl font-bold text-center py-6'>
                    <span className='text-green-600'>Street Horticulture</span>{' '}
                    <span className='text-black'>Inventory</span>
                </h2>
                    <div className='flex flex-col py-2'>
                        <label>Username</label>
                        <input 
                            value={email}
                            required
                            className='border p-2'
                            type={"text"}
                            onChange={(event)=>setEmail(event.target.value)}
                         />
                    </div>
                    <div className='flex flex-col py-2' >
                        <label >Password</label>
                        <input  
                            className='border p-2'
                            type={"password"}
                            value={password}
                            required
                            onChange={(event)=>setPassword(event.target.value)}
                            />
                    </div>
                    <button 
                        className='border w-full my-5 py-2 bg-green-600 hover:bg-green-500 text-white'
                    >Sign In</button>
                    <div className='flex justify-between'>
                        <p className='flex items-center'> <input className='mr-2'type={"checkbox"} /> Remember Me </p>
                    </div>
                </form>
            </div>
        </div>
     );
}
 
export default Login;